// extracted by mini-css-extract-plugin
module.exports = {"title":"wizard_title__1Z4GN","arrow":"wizard_arrow__JUgaL","info":"wizard_info__2Eeu_","logo":"wizard_logo__2-OLY"};